import { formatHtml } from "@trumpf/ux.common-storybook";
import { SearchResultTabsTemplate } from "./search-results.templates";
import { getIframePageDecorators } from "../../../shared/page";

const argTypeDisabled = {
    table: {
        disable: true,
    },
};

export default {
    title: "Website/Page Templates/Search/Search Results",
    render: SearchResultTabsTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        withStaticResults: argTypeDisabled,
        withTabPages: argTypeDisabled,
        withTabProducts: argTypeDisabled,
        withTabContacts: argTypeDisabled,
        withTabDownloads: argTypeDisabled,
        withTabEvents: argTypeDisabled,
        withTabGPT: argTypeDisabled,
    },
};

export const Default = {
    args: {
        noNavigation: true,
        withStaticResults: true,
        withTabPages: true,
    },
};

/**
 * Page search results are displayed as a list of links.
 *
 * **Example API response:**
 * <a href="./mock-data/website-search-results_c-pages.html" target="_blank">Example response for pages</a>
 */
export const TabPages = {
    args: {
        noNavigation: undefined,
        withStaticResults: true,
        withTabPages: true,
        withFilter: true,
        withSort: true,
    },
};

/**
 * Product search results are displayed as a grid of product tiles.
 *
 * **Example API response:**
 * <a href="./mock-data/website-search-results_c-products.html" target="_blank">Example response for products</a>
 */
export const TabProducts = {
    args: {
        noNavigation: undefined,
        withStaticResults: true,
        withTabProducts: true,
        withFilter: true,
        withSort: true,
    },
};

/**
 * Download search results are displayed as a list of teaser download tiles.
 *
 * **Example API response:**
 * <a href="./mock-data/website-search-results_c-downloads.html" target="_blank">Example response for downloads</a>
 */
export const TabDownloads = {
    args: {
        noNavigation: undefined,
        withStaticResults: true,
        withTabDownloads: true,
        withSort: true,
    },
};

/**
 * Contact search results are displayed as a list of contact tiles.
 *
 * **Example API response:**
 * <a href="./mock-data/website-search-results_c-contacts.html" target="_blank">Example response for contacts</a>
 */
export const TabContacts = {
    args: {
        noNavigation: undefined,
        withStaticResults: true,
        withTabContacts: true,
        withSort: true,
    },
};

/**
 * Event search results are displayed as a list of event tiles.
 *
 * **Example API response:**
 * <a href="./mock-data/website-search-results_c-events.html" target="_blank">Example response for events</a>
 */
export const TabEvents = {
    args: {
        noNavigation: undefined,
        withStaticResults: true,
        withTabEvents: true,
        withSort: true,
    },
};

/**
 * All search results are grouped by category and displayed as sliders.
 *
 * **Example API response:**
 * <a href="./mock-data/website-search-results_c-all-categories.html" target="_blank">Example response for all results</a>
 */
export const TabAll = {
    args: {
        noNavigation: undefined,
        withTabAllCategories: true,
    },
};

/**
 * The GPT Tab contains the **loyjoy** container and code snippet.
 */
export const TabGPT = {
    args: {
        withTabPages: false,
        withTabGPT: true,
    },
};
